import UserRole from "./userRole";

export default class User {

  id!: number;
  uuid!: string;
  type!: number;
  firstName!: string;
  lastName!: string;
  fullName!: string;
  title!: string | null;
  email!: string;
  isVerified!: boolean;
  hasEmailAlert!: number;
  mav1Id!: number | null;
  notaryId!: number | null;
  image!: string | null;
  importedTs!: number | null;
  ip!: string;
  isActive!: boolean;
  isDeleted!: boolean;
  isEmailVerified!: boolean;
  isFirstAuth!: boolean;
  phone!: string;
  timezone!: string;
  userRoleId!: number;
  userRoleName!: string;
  activityStatus!: number;
  authLockedUntilTs!: number | null;
  bounceSubtype!: number | null;
  complaintSubtype!: number | null;
  dealerGroupId!: number | null;
  dealerGroupName!: string | null;
  dealerRegionId!: number | null;
  dealerRegionName!: string | null;
  dealerStoreId!: number | null;
  dealerStoreName!: string | null;
  tutorials!: { type: number, shouldShow: boolean }[];
  numOfFailedAuthAttempts!: number | null;
  numOfFailedVerifAttempts!: number | null;
  isImpersonated!: boolean;
  verifCodeConfirmedTs!: number;
  verifCodeCreatedTs!: number;
  passwdUpdatedTs!: number;
  lastActiveTs!: number;
  lastAuthTs!: number;
  hasInsurance!: boolean;
  orderId!: number | null;
  address!: string;
  address2!: string | null;
  city!: string;
  state!: string;
  zip!: string;
  position!: number;
  squeezeId!: string | null;
  createdTs!: number;
  updatedTs!: number;

  static ACTIVITY_STATUS_OFFLINE = 0;
  static ACTIVITY_STATUS_IDLE = 1;
  static ACTIVITY_STATUS_ACTIVE = 2;

  getFullName() {
    return `${this.firstName} ${this.lastName}`;
  }

  static getActivityStatusMap() {
    return {
      [this.ACTIVITY_STATUS_OFFLINE]: 'Offline',
      [this.ACTIVITY_STATUS_IDLE]: 'Idle',
      [this.ACTIVITY_STATUS_ACTIVE]: 'Active',
    };
  }

  static getActivityStatusName(id: number) {
    return this.getActivityStatusMap()[id];
  }

  /***** ROLES *****/

  isMasterAdmin() {
    return UserRole.isMasterAdmin(this.userRoleId);
  }

  isAdmin() {
    return UserRole.isAdmin(this.userRoleId);
  }

  isScheduler() {
    return UserRole.isScheduler(this.userRoleId);
  }

  isDsc() {
    return UserRole.isDsc(this.userRoleId);
  }

  isAccountManager() {
    return UserRole.isAccountManager(this.userRoleId);
  }

  isLeadOps() {
    return UserRole.isLeadOps(this.userRoleId);
  }

  isDealerGroupManager() {
    return UserRole.isDealerGroupManager(this.userRoleId);
  }

  isDealerRegionalManager() {
    return UserRole.isDealerRegionalManager(this.userRoleId);
  }

  isDealerStoreManager() {
    return UserRole.isDealerStoreManager(this.userRoleId);
  }

  isDealerFinanceManager() {
    return UserRole.isDealerFinanceManager(this.userRoleId);
  }

  isDealerSalesManager() {
    return UserRole.isDealerSalesManager(this.userRoleId);
  }

  isDealerUpperManager() {
    return UserRole.isDealerUpperManager(this.userRoleId);
  }

  isDealerLowerManager() {
    return UserRole.isDealerLowerManager(this.userRoleId);
  }

  isDealerManager() {
    return UserRole.isDealerManager(this.userRoleId);
  }

  isDealerStoreUser() {
    return UserRole.isDealerStoreUser(this.userRoleId);
  }

  isDealerStoreLimitedUser() {
    return UserRole.isDealerStoreLimitedUser(this.userRoleId);
  }

  isNotary() {
    return UserRole.isNotary(this.userRoleId);
  }

  /***** ROLE TYPES *****/

  isAdminType() {
    return UserRole.isAdminType(this.userRoleId);
  }

  isDealerType() {
    return UserRole.isDealerType(this.userRoleId);
  }

  isNotaryType() {
    return UserRole.isNotaryType(this.userRoleId);
  }
}